export default "__VITE_ASSET__22581d3f__"